import React from "react";
import "./style.scss";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import { decrease, increase } from "../../redux/slices/windowSlice";

const ButtonAdd = ({ id }) => {
    const dispatch = useAppDispatch();

    const { products, selectedProducts } = useAppSelector(
        (state: RootState) => state.windowSlice
    );

    const type = () => {
        for (const product of products) {
            const item = product.items.find((item) => item.id === id);
            if (item) {
                return product.type;
            }
        }
        return "one-time";
    };

    let count = selectedProducts.selected_product_items.find((product) => product.product_item_id === id)?.count || 0;

    const handleIncrease = () => {
        if (!["one-time"].includes(type()) || count === 0) {
            dispatch(increase({ id }));
        }
    }

    const handleDecrease = () => {
        dispatch(decrease({ id }));
    }

    const simpleBtn = () => {
        if (count > 0) {
            return "button-cart button-cart_simple selected";
        }
        return "button-cart button-cart_simple";
    };

    return (
        <div className={simpleBtn()}>
            <button className="button-cart_remove" onClick={() => handleDecrease()}>
                <div className="button-cart_remove_icon"></div>
            </button>
            <span
                className="button-cart_count"
                style={
                    count % 2
                        ? { animationName: "badge-incr" }
                        : { animationName: "badge-incr2" }
                }>
                {count}
            </span>
            <button className="button-cart_plus" onClick={() => handleIncrease()}
                style={["one-time"].includes(type()) && count === 1 ? {background: "#C4C4C4", cursor: "not-allowed"} : {}}
                >
                <span className="button-cart_plus_text">Добавить</span>
                <div className="button-cart_plus_icon"></div>
            </button>
        </div>
    );
};

export default ButtonAdd;
